<template>
  <lp-number-input
    :model-value="zipValue"
    :label-top="labelTop"
    :placeholder="placeholder"
    :status="status"
    :message="message"
    :required="required"
    :preview="preview"
    format="zip"
    v-bind="$attrs"
    @update:model-value="updateModelValue"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'

defineOptions({
  name: 'lp-zip-input',
})

const emit = defineEmits(['update:model-value'])

interface Props {
  modelValue: number | null
  labelTop?: string | null
  placeholder?: string | null
  status?: string
  message?: string | null
  required?: boolean
  preview?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: null,
  labelTop: null,
  placeholder: null,
  status: 'neutral',
  message: null,
  required: false,
  preview: false,
})

const zipValue = computed(() => props.modelValue)

const updateModelValue = (value: number) => {
  emit('update:model-value', value)
}
</script>
